import { render, staticRenderFns } from "./userAccountFlowRecord.vue?vue&type=template&id=4ab4d06b&scoped=true&"
import script from "./userAccountFlowRecord.vue?vue&type=script&lang=js&"
export * from "./userAccountFlowRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab4d06b",
  null
  
)

export default component.exports